const isSecureURL = (url: string) => url && url.startsWith("https://");

export default isSecureURL;
